import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import exampleCofig from './example-config.json';
import SlideImageContext from './contexts/SlideImageContext'
import { SlideImageBackground } from './containers/SlideImageBackground';

function defaultFn(modules, config, el, message) {
  ReactDOM.render(
    <React.StrictMode>
      <SlideImageContext.Provider value={{ioc: modules.ioc, device: modules.device, navigation : modules.navigation, realDevice: modules.realDevice, config : config, message: message, locale: modules.locale}}>
        <SlideImageBackground />
      </SlideImageContext.Provider>
    </React.StrictMode>,
    el
  );
}

let scafoldingElement = document.getElementById("fc80d7f7-867d-49d4-90d1-a22fd6922a60")

if (scafoldingElement && window.__CHI_API) {

  window.__CHI_API.then(function(chiAPI) {

    let modules = chiAPI.modules
    let message = chiAPI.message

    defaultFn(
      modules,
      exampleCofig,
      scafoldingElement,
      message
    )
  })
}
else {
  window['slideImageBackground'] = {
    default: defaultFn
  }
}

export default defaultFn
